import type { nodeNewExecutor } from "~/js/utilities/changeNodeExecutorOnCustom";
import { extractAdditionalParamsFromTask } from "./midjourney";

export const clingExecutor = extractAdditionalParamsFromTask((jsonData, node) => {
	jsonData.inputs.push({
		name: "task_id",
		value: `${node.meta.taskID}`,
		type: "text"
	});
});

export const clingExtendExecutor: nodeNewExecutor = (node, layout, initialExecutor) => {
	initialExecutor(node, layout);
	node.getAdditionalParamsForTask = (jsonData) => {
		jsonData.inputs.push(
			{
				name: "task_id",
				value: `${node.meta.fromTaskID}`,
				type: "text"
			},
			{
				name: "video_num",
				value: `${node.meta.fromImageIndex + 1}`,
				type: "text"
			}
		);
	};
};
